import React from 'react'
import { Button, Col, Modal, Row } from 'antd'
import CommonMachineCard from '../../../../components/common/others/common-machine-card'
import { clearEmptyPlateFromTempZone } from '../../../../services/others/temporary-zone-services'
import SweetAlertService from '../../../../services/lib/utils/sweet-alert-service'

interface ClearEmptyPalletModalProps {
  visible: boolean
  data: any[]
  onCancel: () => void
  onCleared: () => void
}

export const ClearEmptyPalletModal: React.FC<ClearEmptyPalletModalProps> = (props) => {
  const emptyPallets = (props.data || []).filter((plate: any) => !plate.boxes || plate.boxes.length === 0)

  const handleClearAll = async () => {
    const confirmed = await SweetAlertService.confirmMessage(`Clear all ${emptyPallets.length} empty pallet(s)? This is irreversible.`)
    if (!confirmed) return
    await clearEmptyPlateFromTempZone()
    SweetAlertService.successMessage('Empty pallets cleared.')
    props.onCleared()
  }

  return (
    <Modal
      title="Clear Empty Pallet"
      visible={props.visible}
      onCancel={props.onCancel}
      width={1000}
      destroyOnClose={true}
      footer={[
        <Button key="cancel" onClick={props.onCancel}>Cancel</Button>,
        <Button key="clear" type="primary" danger disabled={emptyPallets.length === 0} onClick={handleClearAll}>Clear All</Button>
      ]}
    >
      <Row gutter={[16, 16]}>
        {emptyPallets.length === 0 ?
          <Col span={24}>
            <div style={{textAlign: 'center', padding: '2rem 0', color: '#999'}}>No empty pallets</div>
          </Col> :
          emptyPallets.map((plate: any, index: number) => (
            <Col key={plate.plateId ?? index} flex="0 0 20%">
              <CommonMachineCard img={'https://jadcup.oss-cn-hongkong.aliyuncs.com/7767c281-6989-4601-a9d0-d47596a9a8f9'} machine={plate.plateCode}/>
            </Col>
          ))
        }
      </Row>
    </Modal>
  )
}
